import React from "react";
import PropTypes from "prop-types";
import { remove } from "lodash"

import {
  TakeawayMessages,
  SkipSection,
  ReagentDragDrop,
  GelDragDropQuestion,
  GelResults,
  MaterialsList,
  FullWidthCard,
  SubHeading,
  Heading,
  QuestionCSCQ,
  QuestionColor,
  FullWidthImage,
  FullWidthAnimation,
  ProtocolTableActual,
  ProtocolTableIdeal,
  ResultsComparisonGel,
  QuestionTable,
  ProtocolTableIdealGel,
} from "@learningblocks/exp-components";
import {
  HighlightHTML,
  GlossaryProvider,
  SingleSelectWithRedux,
  SummaryList,
  NoteBanner
  //GelDragDropQuestion,
} from "@learningblocks/storybook-components";
import { COMPONENT_TYPE } from "@learningblocks/protocol-constants/lib/Utilities";
import { getContentDetails } from "../../../GlossaryAPI";
import { GelDropDown } from "@learningblocks/exp-components/lib/GelDropDown/GelDropDown";

export function ContentItems(props) {
  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  const renderByType = (component, key) => {
    switch (component.type) {
      case COMPONENT_TYPE.PLAIN_TEXT:
        return (
          <div style={{lineHeight: 1.5, color: "#333"}}>
            <HighlightHTML
              key={key}
              content={component.text}
              getContentData={getContentDetails}
              openGlossary={onOpenGlossary}
            />
          </div>
        );
      case COMPONENT_TYPE.BANNER:
          return (
            <div style={{marginTop: '24px'}}>
              <NoteBanner
                text={component.banner}
                openGlossary={onOpenGlossary}
                getContentData={getContentDetails}
              />
            </div>
          );
      case COMPONENT_TYPE.REAGENT_DRAG_DROP:
        return <ReagentDragDrop key={key} {...component} />;
      case COMPONENT_TYPE.RESULT_COMPARISON_GEL:
        return <ResultsComparisonGel key={key} {...component} />;

      case 'GEL_DROP_DOWN':
        return <GelDropDown key={key} {...component} />;
        
      case COMPONENT_TYPE.GEL_DRAG_DROP_QUESTION:
        return <GelDragDropQuestion
                key={key}
                getContentData={getContentDetails}
                openGlossary={onOpenGlossary}
                {...component}
              />;
      case COMPONENT_TYPE.QUESTION_TABLE:
        return <QuestionTable key={key} {...component} />;
      case COMPONENT_TYPE.GEL_RESULTS:
        return <GelResults key={key} {...component} />;
      case COMPONENT_TYPE.MATERIALS_LIST:
        return <MaterialsList key={key} {...component} />;
      case COMPONENT_TYPE.SKIP_SECTION:
        return <SkipSection key={key} {...component} />;
      case COMPONENT_TYPE.SUMMARY_TEXT:
        return <SummaryList key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_ACTUAL:
        return <ProtocolTableActual key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_IDEAL:
        return <ProtocolTableIdeal key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_IDEAL_GEL:
        return <ProtocolTableIdealGel key={key} {...component} />;
      case COMPONENT_TYPE.TAKEAWAY_MESSAGES:
        return <TakeawayMessages key={key} {...component} />;
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return (
          <FullWidthImage
            key={key}
            className="fullWidthImage-item"
            getContentData={getContentDetails}
            openGlossary={onOpenGlossary}
            {...component}
          />
        );
      case COMPONENT_TYPE.FULL_WIDTH_ANIMATION:
        return (
          <FullWidthAnimation
            key={key}
            className="fullWidthAnimation-item"
            {...component}
          />
        );
      case COMPONENT_TYPE.SUB_HEADING:
        return <SubHeading key={key} {...component} />;
      case COMPONENT_TYPE.HEADING:
        return <Heading key={key} {...component} />;
      case COMPONENT_TYPE.FULL_WIDTH_CARD:
        return <FullWidthCard key={key} {...component} />;
      case COMPONENT_TYPE.SINGLE_SELECT_CSCQ:
        return <SingleSelectWithRedux key={key} {...component} />;
      case COMPONENT_TYPE.CSCQ:
      case COMPONENT_TYPE.DDQ:
      case COMPONENT_TYPE.MSCQ:
      case COMPONENT_TYPE.OEQ:
      case COMPONENT_TYPE.NEQ:
      case COMPONENT_TYPE.GROUPED_CSCQ:
        return <QuestionCSCQ key={key} {...component} />;
      case COMPONENT_TYPE.DNDQ_COLOR:
      case COMPONENT_TYPE.CSCQ_COLOR:
      case COMPONENT_TYPE.GROUPED_DNDQ:
        return <QuestionColor key={key} {...component} />;
      default:
        return null;
    }
  };
  const components = handleRandomizedcomponents(props.components)
  return components.map(renderByType);
}

function handleRandomizedcomponents(contents){
  const groups = groupRandomComponents(contents);
  const cleanedContents = removeRestOfRandomComponents(groups, contents);
  return cleanedContents
}

function groupRandomComponents(contents) {
  const groups = {}
  for (let item of contents) {
    if (item.randomGroupId) {
      let id = item.randomGroupId + "";
      groups[id]
        ? groups[id].push(item)
        : groups[id] = [item];
    }
  }
  return groups
}

function removeRestOfRandomComponents(groups, contents) {
  for (let groupId in groups) {
    const randomGroup = groups[groupId];
    if (randomGroup.length > 1) {
      let chosenComponent = randomGroup[Math.floor(Math.random() * randomGroup.length)];
      remove(randomGroup, chosenComponent);

      for (let component of randomGroup) {
        remove(contents, component);
      }
    }
  }
  return contents
}

ContentItems.propTypes = {
  components: PropTypes.array.isRequired,
};
